import {Controller} from '@hotwired/stimulus';
import Axios from '../axios';
import {initLightbox} from "../lightbox";

export default class extends Controller {

    connect() {
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];
        this.timeout = 0;

        this.element.addEventListener('click', (e) => {
            const matchesSingle = e.target.matches('article, article *');
            if (matchesSingle) {
                this.setActiveElement(e.target.closest('article'));
            }
        });

        this.element.addEventListener('click', (e) => {
            const matchesClose = e.target.matches('.close-icon, .close-icon *');
            if (matchesClose) {
                const fullProject = this.element.querySelector('.single-project-full');
                if (fullProject) {
                    fullProject.remove();
                }
            }
        });
    }

    setActiveElement(element) {
        document.querySelectorAll('.single-project-full').forEach((elm) => {
            elm.remove();
        });

        document.querySelectorAll('.single-project').forEach((elm) => {
            elm.classList.remove('active');
        });
        element.classList.add('active');

        const lastRowElement = this.getLastRowElement(element);
        if (!lastRowElement.nextElementSibling) {
            this.element.insertAdjacentHTML('beforeend', '<div class="single-project-full"></div>');
        } else {
            lastRowElement.insertAdjacentHTML('afterend', '<div class="single-project-full"></div>');
        }

        const fullProject = this.element.querySelector('.single-project-full');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.getContent(element).then((response) => {
                if (response && response.data && fullProject) {
                    fullProject.innerHTML = response.data;
                    fullProject.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                    initLightbox();
                }
            });
        }, 200);
    }

    getLastRowElement(element) {
        const parentElement = this.element;
        const elementWidth = element.offsetWidth;
        const offsetRight = parentElement.clientWidth - element.offsetLeft - element.offsetWidth;
        let position = Math.round(offsetRight / elementWidth);
        let sibling = element;
        while (position) {
            position--;
            if (sibling.nextElementSibling) {
                sibling = sibling.nextElementSibling;
            } else {
                break;
            }
        }
        return sibling;
    }

    async getContent(element) {
        element.classList.add('loading');
        const data = {
            rest_language: this.currentLanguageCode,
        };

        const params = Object.keys(data).map(function (k) {
            return `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
        }).join('&');

        let response = null;
        try {
            response = await Axios.get(`/bsw/api/project/single/${element.id}?${params}`);
            response = response.data.data;
        } catch (error) {
            response = error.response.data.data;
        }

        element.classList.remove('loading');
        return response;
    }
}
